export default __webpack_public_path__ + "static/iphone11-312dc23520cef727824fb776e2d9fe14.png";